import { useQuery } from 'react-query';
import { MEDICAL_MEMBERS } from '../../constants/reactQuery.keys';
import { getMedicalMembers } from '../../services/MedicalMembers';

export function useMedicalMembers() {
  return useQuery([MEDICAL_MEMBERS], () => getMedicalMembers());
}

export { MEDICAL_MEMBERS } from '../../constants/reactQuery.keys';
